import React from "react";
import { Link } from "react-router-dom";
import { IconType } from "react-icons/lib";

import logoPrimaryHover from "assets/images/logo/logo2025-secondary_hover.svg";

import SocialIconLink from "./SocialIconLink";
import { cn } from "lib/utils";
import { ROUTES } from "routes";

export interface SocialLink {
    href: string;
    label: string;
    Icon: IconType;
}

interface BrandBlockProps {
    description: React.ReactNode;
    socialLinks: SocialLink[];
    className?: string;
}

const BrandBlock: React.FC<BrandBlockProps> = ({ description, socialLinks, className }) => (
    <div className={cn("space-y-4 md:space-y-10", className)}>
        <Link to={ROUTES.HOME}>
            <img src={logoPrimaryHover} alt="Logo Twoghether" className="h-10 w-auto" />
        </Link>

        <p className="text-sm text-slate-400">{description}</p>

        <div className="flex items-center gap-3">
            {socialLinks.map(({ href, label, Icon }) => (
                <SocialIconLink key={label} href={href} label={label} Icon={Icon} />
            ))}
        </div>
    </div>
);

export default BrandBlock;
